export const _confidenceTypes = {
  tossUp: 'Toss-Up',
  heavyFavorite: 'Heavy Favorite',
  strongFavorite: 'Strong Favorite',
  favorite: 'Favorite',
  slightEdge: 'Slight Edge',
}

const calculateElo = ({ teams, matches, applyGroupBoost, asOfDate }) => {

  const ratings = {};
  const matchesPlayed = {};

  const sectionStats = get_sectionStats({ teams, matches })

  const getInitialRating = (team) => {
    return 1500;
  };

  // init
  _.forEach(teams, (team, itemKey) => {
    const { _itemKey } = team ?? {}
    const _key = _itemKey || itemKey
    ratings[_key] = getInitialRating(team);
    matchesPlayed[_key] = 0;
  });

  const getExpected = (ra, rb) => {
    return 1 / (1 + Math.pow(10, (rb - ra) / 400));
  };

  const getK = (mc) => {
    if (mc < 5) return 40;
    if (mc < 10) return 30;
    return 20;
  };

  // TRUE Elo score (important fix)
  const getMatchScore = (setsFor, setsAgainst) => {
    return setsFor > setsAgainst ? 1 : 0;
  };

  // Stable volleyball MOV multiplier (capped)
  const getMOVMultiplier = (setsFor, setsAgainst) => {
    const diff = Math.abs(setsFor - setsAgainst);
    return 1 + Math.min(diff * 0.2, 0.5);
  };

  const HOME_ADVANTAGE = 50; // set to 50–100 if you want

  _.forEach(matches, match => {
    const results = match?._results;
    if (!results || !results.score || _.isEmpty(results.score)) return;

    const homeId = match.home?._itemKey || match.home?.id;
    const awayId = match.away?._itemKey || match.away?.id;

    if (!homeId || !awayId) return;

    const setsHome = results.score.home;
    const setsAway = results.score.away;

    const ratingHome = ratings[homeId];
    const ratingAway = ratings[awayId];

    const homeKey = getGroupKey(match.home);
    const awayKey = getGroupKey(match.away);

    // const groupBoost = 0 //applyGroupBoost ? (sectionOffsets[homeKey] || 0) - (sectionOffsets[awayKey] || 0) : 0;
    const groupBoost = (sectionStats[homeKey]?.offset || 0) - (sectionStats[awayKey]?.offset || 0);

    const expectedHome = getExpected(ratingHome + HOME_ADVANTAGE + groupBoost, ratingAway);
    const expectedAway = 1 - expectedHome;

    const kHome = getK(matchesPlayed[homeId]);
    const kAway = getK(matchesPlayed[awayId]);

    const scoreHome = getMatchScore(setsHome, setsAway);
    const scoreAway = getMatchScore(setsAway, setsHome);

    const multiplier = getMOVMultiplier(setsHome, setsAway);

    const newHome = ratingHome + kHome * multiplier * (scoreHome - expectedHome);
    const newAway = ratingAway + kAway * multiplier * (scoreAway - expectedAway);

    if (newHome) { ratings[homeId] = newHome; }
    if (newAway) { ratings[awayId] = newAway; }

    matchesPlayed[homeId] += 1;
    matchesPlayed[awayId] += 1;
  });

  // build result
  const elos = {};

  _.forEach(teams, (team, itemKey) => {
    const { _itemKey } = team ?? {}
    const _key = _itemKey || itemKey
    elos[_key] = {
      elo: Math.round(ratings[_key]),
      elo_raw: ratings[_key],
      matchesPlayed: matchesPlayed[_key]
    };
  });


  return { elos, sectionStats };

};

const enhanceEloInsights = ({ teamsWithElo, matches, teams, topN = 3 }) => {

  const insights = {};

  // init
  _.forEach(teamsWithElo, (team, itemKey) => {
    const { _itemKey } = team ?? {}
    const _key = _itemKey || itemKey
    insights[_key] = {
      opponents: [],
      winsVsHigherRated: 0,
      totalOpponentElo: 0,
      games: 0,
      expectedWins: 0,
      actualWins: 0,
      recent: [],
      bestWin: null,
      worstLoss: null,
      bestWins: [],
      worstLosses: [],
      homeMatches: 0,
      homeWins: 0
    };
  });

  const getExpected = (ra, rb) => {
    return 1 / (1 + Math.pow(10, (rb - ra) / 400));
  };

  // process matches
  _.forEach(matches, match => {

    const results = match?._results;
    if (!results || !results.score) return;

    const { score, scoreDisplays } = results ?? {}
    const { normal } = scoreDisplays ?? {}

    const homeId = match.home?._itemKey || match.home?.id;
    const awayId = match.away?._itemKey || match.away?.id;

    if (!teamsWithElo[homeId] || !teamsWithElo[awayId]) return;

    const setsHome = score.home;
    const setsAway = score.away;

    if (setsHome == null || setsAway == null) return;

    const homeWon = setsHome > setsAway;

    const _eloInfoH = teamsWithElo[homeId] //.record.eloInfo
    const _eloInfoA = teamsWithElo[awayId] //.record.eloInfo

    const eloHome = _eloInfoH.elo_raw;
    const eloAway = _eloInfoA.elo_raw;

    const expectedHome = getExpected(eloHome, eloAway);
    const expectedAway = 1 - expectedHome;

    // --- HOME --- 
    insights[homeId].matches += 1;
    insights[homeId].totalOpponentElo += eloAway;
    insights[homeId].expectedWins += expectedHome;
    insights[homeId].actualWins += homeWon ? 1 : 0;
    insights[homeId].opponents.push(awayId);

    insights[homeId].recent.push(homeWon ? 'W' : 'L');

    if (homeWon && eloAway > eloHome) {
      insights[homeId].winsVsHigherRated += 1;
    }

    // best win
    if (homeWon) {
      insights[homeId].homeMatches++
      if (score.home > score.away) {
        insights[homeId].homeWins += 1;
      }
      if (!insights[homeId].bestWin || eloAway > insights[homeId].bestWin.opponentElo) {
        insights[homeId].bestWin = {
          opponentId: awayId,
          opponentElo: eloAway
        };
        insights[homeId].bestWins.push({
          opponentId: awayId,
          opponentElo: eloAway,
          name: teams?.[awayId]?.name,
          result: normal
        });
      }
    }

    // worst loss
    if (!homeWon) {
      insights[homeId].homeMatches++
      if (!insights[homeId].worstLoss || eloAway < insights[homeId].worstLoss.opponentElo) {
        insights[homeId].worstLoss = {
          opponentId: awayId,
          opponentElo: eloAway
        };
        insights[homeId].worstLosses.push({
          opponentId: awayId,
          opponentElo: eloAway,
          name: teams?.[awayId]?.name,
          result: normal
        });
      }
    }

    // --- AWAY ---
    insights[awayId].matches += 1;
    insights[awayId].totalOpponentElo += eloHome;
    insights[awayId].expectedWins += expectedAway;
    insights[awayId].actualWins += homeWon ? 0 : 1;
    insights[awayId].opponents.push(homeId);

    insights[awayId].recent.push(homeWon ? 'L' : 'W');

    if (!homeWon && eloHome > eloAway) {
      insights[awayId].winsVsHigherRated += 1;
    }

    if (!homeWon) {
      if (!insights[awayId].bestWin || eloHome > insights[awayId].bestWin.opponentElo) {
        insights[awayId].bestWin = {
          opponentId: homeId,
          opponentElo: eloHome,
          name: teams?.[homeId]?.name
        };
        insights[awayId].bestWins.push({
          opponentId: homeId,
          opponentElo: eloHome,
          name: teams?.[homeId]?.name,
          result: normal
        });
      }
    }

    if (homeWon) {
      if (
        !insights[awayId].worstLoss || eloHome < insights[awayId].worstLoss.opponentElo) {
        insights[awayId].worstLoss = {
          opponentId: homeId,
          opponentElo: eloHome,
          name: teams?.[homeId]?.name
        };
        insights[awayId].worstLosses.push({
          opponentId: homeId,
          opponentElo: eloHome,
          name: teams?.[homeId]?.name,
          result: normal
        });
      }
    }

  });

  _.forEach(insights, (data) => {

    data.bestWins = _
      .chain(data.bestWins)
      .orderBy(['opponentElo'], ['desc'])
      .take(topN)
      .value();

    data.worstLosses = _
      .chain(data.worstLosses)
      .orderBy(['opponentElo'], ['asc'])
      .take(topN)
      .value();

  });

  // finalize + merge back into teams
  const result = {};

  _.forEach(teamsWithElo, (team, itemKey) => {

    const { _itemKey } = team ?? {}
    const _key = _itemKey || itemKey

    const data = insights[_key];

    const strengthOfSchedule = data.matches > 0 ? data.totalOpponentElo / data.matches : 0;

    const performanceDelta = data.actualWins - data.expectedWins;

    result[_key] = {
      actualWins: data.actualWins,
      bestWins: data.bestWins,
      expectedWins: Number(data.expectedWins.toFixed(2)),
      performanceDelta: Number(performanceDelta.toFixed(2)),
      strengthOfSchedule: Number(strengthOfSchedule.toFixed(1)),
      winsVsHigherRated: data.winsVsHigherRated,
      worstLosses: data.worstLosses,
      homeMatches: data.homeMatches,
      homeWins: data.homeWins,
      homeWinPct: data.homeMatches > 0 ? Number((data.homeWins / data.homeMatches).toFixed(3)) : 0
    };

  });

  return result;
};

const calculateRpi = ({ teams, matches }) => {

  const records = {};
  const opponents = {};

  // init
  _.forEach(teams, (team, itemKey) => {
    records[itemKey] = {
      wins: 0,
      losses: 0,
      matches: 0
    };
    opponents[itemKey] = [];
  });

  // build records + opponent lists
  _.forEach(matches, match => {
    const results = match?._results;
    if (!results || !results.score || _.isEmpty(results.score)) return;

    const homeId = match.home?._itemKey || match.home?.id;
    const awayId = match.away?._itemKey || match.away?.id;

    if (!homeId || !awayId) return;
    if (!records[homeId] || !records[awayId]) return;

    const setsHome = results?.score?.home;
    const setsAway = results?.score?.away;

    // determine winner/loser
    const homeWon = setsHome > setsAway;

    if (homeWon) {
      records[homeId].wins += 1;
      records[awayId].losses += 1;
    } else {
      records[awayId].wins += 1;
      records[homeId].losses += 1;
    }

    records[homeId].matches += 1;
    records[awayId].matches += 1;

    opponents[homeId].push(awayId);
    opponents[awayId].push(homeId);
  });

  // WP
  const wp = {};
  _.forEach(records, (rec, teamId) => {
    wp[teamId] = rec.matches > 0 ? rec.wins / rec.matches : 0;
  });

  // OWP (exclude matches vs current team)
  const owp = {};

  _.forEach(teams, (team, teamId) => {

    const oppList = opponents[teamId];

    const values = _.map(oppList, oppId => {

      const oppRec = records[oppId];

      // remove matches vs this team
      let adjWins = oppRec.wins;
      let adjLosses = oppRec.losses;

      _.forEach(matches, match => {
        const results = match?._results;
        if (!results || !results.score) return;

        const homeId = match.home?._itemKey || match.home?.id;
        const awayId = match.away?._itemKey || match.away?.id;

        const isMatch =
          (homeId === teamId && awayId === oppId) ||
          (homeId === oppId && awayId === teamId);

        if (!isMatch) return;

        const setsHome = results?.score?.home;
        const setsAway = results?.score?.away;

        const homeWon = setsHome > setsAway;

        if (homeId === oppId) {
          if (homeWon) adjWins -= 1;
          else adjLosses -= 1;
        } else {
          if (!homeWon) adjWins -= 1;
          else adjLosses -= 1;
        }
      });

      const total = adjWins + adjLosses;
      return total > 0 ? adjWins / total : 0;
    });

    owp[teamId] = values.length ? _.mean(values) : 0;
  });

  // OOWP
  const oowp = {};
  _.forEach(teams, (team, teamId) => {
    const oppList = opponents[teamId];
    const values = _.map(oppList, oppId => owp[oppId] || 0);
    oowp[teamId] = values.length ? _.mean(values) : 0;
  });



  // final RPI
  const result = {};

  _.forEach(teams, (team, teamId) => {
    const rpi =
      (0.25 * (wp[teamId] || 0)) +
      (0.5 * (owp[teamId] || 0)) +
      (0.25 * (oowp[teamId] || 0));

    result[teamId] = {
      ...team,
      _rpiInfo: {
        rpi: Number(rpi.toFixed(4)),
        wp: wp[teamId] || 0,
        owp: owp[teamId] || 0,
        oowp: oowp[teamId] || 0,
        wins: records[teamId].wins,
        losses: records[teamId].losses,
        matches: records[teamId].matches
      }
    };
  });

  return result;
};

const getGroupKey = (team) => {
  return `${team.levels}_${team.sections}`;
};

const getLevel = (team) => team.levels;

const get_sectionStats = ({ teams, matches }) => {

  const sectionStats = {};

  _.forEach(matches, m => {

    const r = m?._results;
    if (!r || !r.score) return;

    const home = teams[m.home?._itemKey || m.home?.id];
    const away = teams[m.away?._itemKey || m.away?.id];

    if (!home || !away) return;

    const homeKey = getGroupKey(home);
    const awayKey = getGroupKey(away);

    const homeLevel = getLevel(home);
    const awayLevel = getLevel(away);

    // skip same section/level
    if (homeKey === awayKey) return;

    const homeWon = r.score.home > r.score.away;

    // init
    sectionStats[homeKey] ||= {
      key: homeKey,
      wins: 0,
      losses: 0,
      overallMatches: 0,
      levelMatches: {}
    };

    sectionStats[awayKey] ||= {
      key: awayKey,
      wins: 0,
      losses: 0,
      overallMatches: 0,
      levelMatches: {}
    };

    // ensure level buckets exist
    sectionStats[homeKey].levelMatches[awayLevel] ||= {
      wins: 0,
      losses: 0,
      matches: 0
    };

    sectionStats[awayKey].levelMatches[homeLevel] ||= {
      wins: 0,
      losses: 0,
      matches: 0
    };

    // -------------------
    // OVERALL
    // -------------------
    sectionStats[homeKey].overallMatches += 1;
    sectionStats[awayKey].overallMatches += 1;

    // -------------------
    // LEVEL-SPECIFIC
    // -------------------
    sectionStats[homeKey].levelMatches[awayLevel].matches += 1;
    sectionStats[awayKey].levelMatches[homeLevel].matches += 1;

    if (homeWon) {
      sectionStats[homeKey].wins += 1;
      sectionStats[awayKey].losses += 1;

      sectionStats[homeKey].levelMatches[awayLevel].wins += 1;
      sectionStats[awayKey].levelMatches[homeLevel].losses += 1;
    } else {
      sectionStats[awayKey].wins += 1;
      sectionStats[homeKey].losses += 1;

      sectionStats[awayKey].levelMatches[homeLevel].wins += 1;
      sectionStats[homeKey].levelMatches[awayLevel].losses += 1;
    }

    // sectionStats[homeKey].matches += 1;
    // sectionStats[awayKey].matches += 1;

    // if (homeWon) {
    //   sectionStats[homeKey].wins += 1;
    //   sectionStats[awayKey].losses += 1;
    // } else {
    //   sectionStats[awayKey].wins += 1;
    //   sectionStats[homeKey].losses += 1;
    // }

  });

  _.forEach(sectionStats, stat => {

    // OVERALL
    stat.winPct =
      stat.overallMatches > 0
        ? Number((stat.wins / stat.overallMatches).toFixed(3))
        : 0.5;

    stat.offset = Number(((stat.winPct - 0.5) * 150).toFixed(1));

    // LEVEL BREAKDOWN
    _.forEach(stat.levelMatches, levelStat => {

      levelStat.winPct =
        levelStat.matches > 0
          ? Number((levelStat.wins / levelStat.matches).toFixed(3))
          : 0.5;

      levelStat.offset =
        Number(((levelStat.winPct - 0.5) * 150).toFixed(1));

    });

  });

  // calculate winPct + offset
  // _.forEach(sectionStats, stat => {

  //   stat.winPct = stat.overallMatches > 0 ? Number((stat.wins / stat.overallMatches).toFixed(3)) : 0.5;
  //   // stat.winPct = stat.overallMatches > 0 ? Number((stat.wins / stat.overallMatches).toFixed(3)) : 0.5;

  //   // centered around 0
  //   stat.offset = Number(((stat.winPct - 0.5) * 150).toFixed(1));

  // });

  const rankedOverall = _
    .chain(sectionStats)
    .values()
    .orderBy(
      ['offset', 'winPct', 'wins'],
      ['desc', 'desc', 'desc']
    )
    .value();

  // overall rank
  _.forEach(rankedOverall, (stat, index) => {
    stat.overallRank = index + 1;
  });

  // level rank
  const groupedByLevel = _.groupBy(rankedOverall, stat => {
    return stat.key.split('_')[0]; // assumes section_level format
  });

  _.forEach(groupedByLevel, levelGroups => {

    const rankedLevel = _.orderBy(
      levelGroups,
      ['offset', 'winPct', 'wins'],
      ['desc', 'desc', 'desc']
    );

    _.forEach(rankedLevel, (stat, index) => {
      stat.levelRank = index + 1;
    });

  });


  return sectionStats;
};

const getTeamVsGroupRecords = ({ teams, matches }) => {

  const result = {};

  // init
  _.forEach(teams, (team, teamId) => {
    result[teamId] = { name: team.name, vs: {} };
  });

  _.forEach(matches, m => {
    const r = m?._results;
    if (!r || !r.score) return;

    const homeId = m.home?._itemKey || m.home?.id;
    const awayId = m.away?._itemKey || m.away?.id;

    const homeTeam = teams[homeId];
    const awayTeam = teams[awayId];

    if (!homeTeam || !awayTeam) return;

    const homeGroup = getGroupKey(homeTeam);
    const awayGroup = getGroupKey(awayTeam);

    // skip same group
    if (homeGroup === awayGroup) return;
    const homeWon = r.score.home > r.score.away;

    // init buckets
    result[homeId].vs[awayGroup] ||= { wins: 0, losses: 0, matches: 0 };
    result[awayId].vs[homeGroup] ||= { wins: 0, losses: 0, matches: 0 };

    // increment matches
    result[homeId].vs[awayGroup].matches += 1;
    result[awayId].vs[homeGroup].matches += 1;

    // increment wins
    if (homeWon) {
      result[homeId].vs[awayGroup].wins += 1;
      result[awayId].vs[homeGroup].losses += 1;
    } else {
      result[awayId].vs[homeGroup].wins += 1;
      result[homeId].vs[awayGroup].losses += 1;
    }
  });

  // add win %
  _.forEach(result, team => {
    _.forEach(team.vs, rec => {
      rec.winPct = rec.matches
        ? Number((rec.wins / rec.matches).toFixed(2))
        : 0;
    });
  });

  return result;
};

const adjustSeedsByHeadToHead = ({ teamsInOrder, matches }) => {

  const getId = (t) => t._itemKey || t.id;

  // helper: did teamA beat teamB?
  const didBeat = (teamAId, teamBId) => {
    let wins = 0;
    let losses = 0;

    _.forEach(matches, m => {
      const r = m?._results;
      if (!r || !r.score) return;

      const homeId = m.home?._itemKey || m.home?.id;
      const awayId = m.away?._itemKey || m.away?.id;

      if (
        (homeId === teamAId && awayId === teamBId) ||
        (homeId === teamBId && awayId === teamAId)
      ) {
        const homeWon = r.score.home > r.score.away;

        if (homeId === teamAId && homeWon) wins++;
        else if (awayId === teamAId && !homeWon) wins++;
        else losses++;
      }
    });

    return wins > losses;
  };

  const result = [...teamsInOrder];

  // 👇 loop from 2nd place downward
  for (let i = 1; i < result.length; i++) {

    let j = i;

    // compare upward
    while (j > 0) {
      const lower = result[j];
      const higher = result[j - 1];

      const lowerId = getId(lower);
      const higherId = getId(higher);

      // if lower beat higher → swap
      if (didBeat(lowerId, higherId)) {
        [result[j - 1], result[j]] = [result[j], result[j - 1]];
        j--; // keep bubbling up
      } else {
        break;
      }
    }
  }

  return result;
};

const getTeamRankingReason = ({ teamId, teams, matches, eloInfo, sectionStats }) => {

  const team = teams[teamId];
  if (!team) return 'Team not found.';

  const elo = eloInfo?.elo;
  const groupKey = `${team.levels}_${team.sections}`;

  const stats = sectionStats?.[groupKey];

  if (!stats) return 'No section data available.';

  const reasons = [];

  // -------------------------
  // 1. OVERALL PERFORMANCE
  // -------------------------
  const winPct = stats.winPct;

  if (winPct >= 0.6) {
    reasons.push(`Strong cross-group performance (${(winPct * 100).toFixed(1)}% wins vs outside opponents).`);
  } else if (winPct <= 0.4) {
    reasons.push(`Struggled vs outside competition (${(winPct * 100).toFixed(1)}% win rate).`);
  } else {
    reasons.push(`Balanced performance vs outside competition.`);
  }

  // -------------------------
  // 2. ELO CONTEXT
  // -------------------------
  if (elo >= 1650) {
    reasons.push(`High Elo rating (${Math.round(elo)}) indicating strong competitive strength.`);
  } else if (elo <= 1450) {
    reasons.push(`Lower Elo rating (${Math.round(elo)}) reflecting inconsistent results.`);
  } else {
    reasons.push(`Mid-range Elo rating (${Math.round(elo)}).`);
  }

  // -------------------------
  // 3. LEVEL PERFORMANCE
  // -------------------------
  const level = team.levels;
  const levelStats = stats.levelMatches?.[level];

  if (levelStats) {
    const levelPct = levelStats.winPct;

    if (levelPct >= 0.6) {
      reasons.push(`Strong performance within Level ${level} (${(levelPct * 100).toFixed(1)}%).`);
    } else if (levelPct <= 0.4) {
      reasons.push(`Struggles within Level ${level} (${(levelPct * 100).toFixed(1)}%).`);
    } else {
      reasons.push(`Average performance within Level ${level}.`);
    }
  }

  // -------------------------
  // 4. STRENGTH OF SECTION CONTEXT
  // -------------------------
  if (stats.offset > 20) {
    reasons.push(`Competing in a strong section (above-average group strength).`);
  } else if (stats.offset < -20) {
    reasons.push(`Competing in a weaker section (below-average group strength).`);
  }

  // -------------------------
  // 5. FINAL SUMMARY LINE
  // -------------------------
  reasons.push(`Overall ranking is driven by Elo performance adjusted for section strength and cross-group results.`);

  return reasons;
};

const get_homeAdvantage = (eloHome) => {

  const homeAdvantage = 25
  const homeWinPct = eloHome?.homeWinPct ?? 0.5;

  // centered around .500
  const adjustment = (homeWinPct - 0.5) * 100;

  // base + adjustment
  return { homeAdvantage: Math.round(homeAdvantage + adjustment), homeWinPct }

};

const getMatchPrediction = ({
  match,
  teams,

  // complex object keyed by matchId
  matches = {},

  includeCommonMatches = false,

}) => {

  const { home: homeTeam, away: awayTeam, location } = match ?? {}

  const { _itemKey: homeKey } = homeTeam ?? {}
  const { _itemKey: awayKey } = awayTeam ?? {}

  if (!awayKey) return;

  const { _itemKey: locationKey } = location ?? {}

  const eloInfo_home =
    teams?.[homeKey]?.record?.eloInfo

  const eloInfo_away =
    teams?.[awayKey]?.record?.eloInfo

  const { homeAdvantage } =
    get_homeAdvantage(eloInfo_home)

  const homeElo =
    eloInfo_home?.elo_raw || 1500;

  const awayElo =
    eloInfo_away?.elo_raw || 1500;

  const _advantage =
    homeKey === locationKey
      ? homeAdvantage
      : 0

  // ---------------------------------------------------
  // DERIVE COMMON MATCHES
  // ---------------------------------------------------
  // matches is a keyed object, not an array.
  //
  // We use _.filter directly on the object.
  //
  // Finds:
  // - completed matches
  // - same exact two teams
  // - excludes current match
  // ---------------------------------------------------

  const previousMatches = _.filter(
    matches,
    (m) => {

      const {
        _itemKey,
        completed,
        home,
        away,
      } = m ?? {}

      const mHomeKey =
        home?._itemKey

      const mAwayKey =
        away?._itemKey

      // exclude current match
      if (_itemKey === match?._itemKey) {
        return false;
      }

      // must be completed
      if (!completed) {
        return false;
      }

      return (

        (
          mHomeKey === homeKey &&
          mAwayKey === awayKey
        ) ||

        (
          mHomeKey === awayKey &&
          mAwayKey === homeKey
        )

      )

    }
  )

  // ---------------------------------------------------
  // SORT MATCHES
  // ---------------------------------------------------
  // oldest -> newest
  // so newer matches receive larger weights
  // ---------------------------------------------------

  const sortedPreviousMatches =
    _.sortBy(
      previousMatches,
      (m) => m?.startTime || 0
    )

  // ---------------------------------------------------
  // COMMON MATCH ADJUSTMENT
  // ---------------------------------------------------

  let commonMatchAdjustment = 0;

  if (
    includeCommonMatches &&
    sortedPreviousMatches.length
  ) {

    let weightedScore = 0;
    let totalWeight = 0;

    _.forEach(
      sortedPreviousMatches,
      (m, index) => {

        const {
          home,
          away,
          homeScore,
          awayScore,
        } = m ?? {}

        const mHomeKey =
          home?._itemKey

        const mAwayKey =
          away?._itemKey

        const homeSets =
          Number(homeScore || 0)

        const awaySets =
          Number(awayScore || 0)

        // newer matches weighted more
        const weight =
          index + 1;

        totalWeight += weight;

        // margin of victory
        const setDiff =
          Math.abs(
            homeSets - awaySets
          )

        let marginMultiplier = 1;

        if (setDiff >= 3) {
          marginMultiplier = 1.5;
        }
        else if (setDiff >= 2) {
          marginMultiplier = 1.25;
        }

        const winnerKey =
          homeSets > awaySets
            ? mHomeKey
            : mAwayKey

        const scoreImpact =
          weight * marginMultiplier

        if (winnerKey === homeKey) {
          weightedScore += scoreImpact;
        }
        else {
          weightedScore -= scoreImpact;
        }

      }
    )

    const normalized =
      totalWeight
        ? weightedScore / totalWeight
        : 0

    // keep impact controlled
    commonMatchAdjustment =
      _.clamp(
        normalized * 35,
        -50,
        50
      );

  }

  // -------------------------
  // HOME ADVANTAGE
  // -------------------------

  const adjustedHome =
    homeElo +
    _advantage +
    commonMatchAdjustment;

  // -------------------------
  // WIN PROBABILITY
  // -------------------------

  const homeWinProb =
    1 / (
      1 + Math.pow(
        10,
        (awayElo - adjustedHome) / 400
      )
    );

  const awayWinProb =
    1 - homeWinProb;

  // -------------------------
  // PREDICTED WINNER
  // -------------------------

  const homeFavored =
    homeWinProb >= awayWinProb;

  const predictedWinner =
    homeFavored
      ? homeTeam
      : awayTeam;

  const predictedLoser =
    homeFavored
      ? awayTeam
      : homeTeam;

  // -------------------------
  // CONFIDENCE
  // -------------------------

  const pct =
    Math.max(
      homeWinProb,
      awayWinProb
    );

  let confidence =
    _confidenceTypes.tossUp;

  if (pct >= 0.85) {
    confidence =
      _confidenceTypes.heavyFavorite;
  }
  else if (pct >= 0.74) {
    confidence =
      _confidenceTypes.strongFavorite;
  }
  else if (pct >= 0.64) {
    confidence =
      _confidenceTypes.favorite;
  }
  else if (pct >= 0.57) {
    confidence =
      _confidenceTypes.slightEdge;
  }

  let confidenceColor = 'black'

  // -------------------------
  // PROJECTED SCORE
  // -------------------------

  let projectedScore = '3-2';

  if (pct >= 0.85) {
    projectedScore = '3-0';
  }
  else if (pct >= 0.7) {
    projectedScore = '3-1';
  }

  const projectedWinnerScore =
    homeFavored
      ? projectedScore
      : projectedScore
        .split('-')
        .reverse()
        .join('-');

  // -------------------------
  // UPSET ALERT
  // -------------------------

  const upsetAlert =
    pct >= 0.8;

  // -------------------------
  // MATCH QUALITY
  // -------------------------

  const avgElo =
    (homeElo + awayElo) / 2;

  let matchQuality = 'Average';

  if (avgElo >= 1700) {
    matchQuality = 'Elite Matchup';
  }
  else if (avgElo >= 1600) {
    matchQuality = 'High-Level Matchup';
  }
  else if (avgElo <= 1450) {
    matchQuality = 'Developing Matchup';
  }

  // -------------------------
  // RETURN
  // -------------------------

  return {

    predictedWinnerId:
      predictedWinner._itemKey ||
      predictedWinner.id,

    predictedLoserId:
      predictedLoser._itemKey ||
      predictedLoser.id,

    homeWinProb:
      Number(
        (homeWinProb * 100)
          .toFixed(1)
      ),

    awayWinProb:
      Number(
        (awayWinProb * 100)
          .toFixed(1)
      ),

    confidence,

    confidenceColor,

    projectedScore:
      projectedWinnerScore,

    eloDiff:
      Math.round(
        homeElo - awayElo
      ),

    upsetAlert,

    matchQuality,

    projectedSets:
      projectedScore,

    commonMatchAdjustment:
      Math.round(
        commonMatchAdjustment
      ),

    commonMatchesCount:
      sortedPreviousMatches.length,

    favoriteTeam: {

      _itemKey:
        predictedWinner._itemKey ||
        predictedWinner.id,

      name:
        predictedWinner.name,

      prob:
        homeWinProb > awayWinProb
          ? Number(
            (homeWinProb * 100)
              .toFixed(1)
          )
          : Number(
            (awayWinProb * 100)
              .toFixed(1)
          )

    }

  };

};

const getMatchPredictionXX = ({
  match,
  teams,
}) => {

  const { home: homeTeam, away: awayTeam, location } = match ?? {}
  const { _itemKey: homeKey } = homeTeam ?? {}
  const { _itemKey: awayKey } = awayTeam ?? {}

  if (!awayKey) return;

  const { _itemKey: locationKey } = location ?? {}

  const eloInfo_home = teams?.[homeKey]?.record?.eloInfo
  const eloInfo_away = teams?.[awayKey]?.record?.eloInfo

  const { homeAdvantage, homeWinPct } = get_homeAdvantage(eloInfo_home)

  const homeElo = eloInfo_home?.elo_raw || 1500;
  const awayElo = eloInfo_away?.elo_raw || 1500;

  const _advantage = homeKey === locationKey ? homeAdvantage : 0

  // -------------------------
  // HOME ADVANTAGE
  // -------------------------
  const adjustedHome = homeElo + _advantage;

  // -------------------------
  // WIN PROBABILITY
  // -------------------------
  const homeWinProb = 1 / (1 + Math.pow(10, (awayElo - adjustedHome) / 400));

  const awayWinProb = 1 - homeWinProb;

  // -------------------------
  // PREDICTED WINNER
  // -------------------------
  const homeFavored = homeWinProb >= awayWinProb;
  const predictedWinner = homeFavored ? homeTeam : awayTeam;
  const predictedLoser = homeFavored ? awayTeam : homeTeam;

  // -------------------------
  // CONFIDENCE
  // -------------------------
  const pct = Math.max(homeWinProb, awayWinProb);

  let confidence = _confidenceTypes.tossUp;

  if (pct >= 0.85) {
    confidence = _confidenceTypes.heavyFavorite;
  }
  else if (pct >= 0.74) {
    confidence = _confidenceTypes.strongFavorite;
  }
  else if (pct >= 0.64) {
    confidence = _confidenceTypes.favorite;
  }
  else if (pct >= 0.57) {
    confidence = _confidenceTypes.slightEdge;
  }

  let confidenceColor = 'black'

  // -------------------------
  // PROJECTED SCORE
  // -------------------------
  let projectedScore = '3-2';

  if (pct >= 0.85) {
    projectedScore = '3-0';
  }
  else if (pct >= 0.7) {
    projectedScore = '3-1';
  }
  else if (pct >= 0.55) {
    projectedScore = '3-2';
  }

  // flip score if away favored
  const projectedWinnerScore =
    homeFavored
      ? projectedScore
      : projectedScore.split('-').reverse().join('-');

  // -------------------------
  // UPSET ALERT
  // -------------------------
  const upsetAlert = pct >= 0.8;

  // -------------------------
  // MATCH QUALITY
  // -------------------------
  const avgElo = (homeElo + awayElo) / 2;

  let matchQuality = 'Average';

  if (avgElo >= 1700) {
    matchQuality = 'Elite Matchup';
  }
  else if (avgElo >= 1600) {
    matchQuality = 'High-Level Matchup';
  }
  else if (avgElo <= 1450) {
    matchQuality = 'Developing Matchup';
  }

  // -------------------------
  // RETURN
  // -------------------------
  return {
    predictedWinnerId: predictedWinner._itemKey || predictedWinner.id,
    predictedLoserId: predictedLoser._itemKey || predictedLoser.id,
    homeWinProb: Number((homeWinProb * 100).toFixed(1)),
    awayWinProb: Number((awayWinProb * 100).toFixed(1)),
    confidence,
    confidenceColor,
    projectedScore: projectedWinnerScore,
    eloDiff: Math.round(homeElo - awayElo),
    upsetAlert,
    matchQuality,
    projectedSets: projectedScore,
    favoriteTeam: {
      _itemKey: predictedWinner._itemKey || predictedWinner.id,
      name: predictedWinner.name,
      prob: homeWinProb > awayWinProb ? Number((homeWinProb * 100).toFixed(1)) : Number((awayWinProb * 100).toFixed(1))
    }
  };
};

const formatRecord = (team = {}) => {
  const w = team?.record?.wins ?? 0
  const l = team?.record?.losses ?? 0
  return `${w}-${l}`
}

const generateMatchSummary = ({
  match,
  standings,
  previousMeetings,
  classification,
}) => {

  const { home: homeTeam, away: awayTeam, location, _matchCollectionKey } = match ?? {}
  const results = match?._results;

  const homeKey = homeTeam?._itemKey
  const awayKey = awayTeam?._itemKey

  const section_home = homeTeam?.sections;
  const section_away = awayTeam?.sections;

  const homeScore = results?.home;
  const awayScore = results?.away;

  const homeWon = homeScore > awayScore

  const winner = homeWon ? homeTeam : awayTeam
  const loser = homeWon ? awayTeam : homeTeam

  const winnerScore = Math.max(homeScore, awayScore)
  const loserScore = Math.min(homeScore, awayScore)

  const winnerRecord = formatRecord(winner)
  const loserRecord = formatRecord(loser)

  const intros = [
    `${winner.name} picked up a key victory`,
    `${winner.name} came away with the win`,
    `${winner.name} earned an important section victory`,
    `${winner.name} defended home court`,
    `${winner.name} continued its strong season`,
    `${winner.name} added another win to its resume`,
  ]

  const scoreLines = [
    `${winner.name} defeated ${loser.name} ${winnerScore}-${loserScore}`,
    `${winner.name} knocked off ${loser.name} by a score of ${winnerScore}-${loserScore}`,
    `${winner.name} earned a ${winnerScore}-${loserScore} victory over ${loser.name}`,
    `${winner.name} topped ${loser.name} ${winnerScore}-${loserScore}`,
  ]

  const standingsLines = [
    `The win moves ${winner.name} to ${winnerRecord} on the season.`,
    `${winner.name} now sits at ${winnerRecord}.`,
    `With the result, ${winner.name} improves to ${winnerRecord}.`,
  ]

  const loserLines = [
    `${loser.name} falls to ${loserRecord}.`,
    `The loss drops ${loser.name} to ${loserRecord} this season.`,
    `${loser.name} now stands at ${loserRecord}.`,
  ]

  const contextLines = [
    winner.sections && `${winner.name} remains in the hunt near the top of the ${winner.sections} standings.`,
    _matchCollectionKey && `The matchup featured two teams from ${_matchCollectionKey}.`,
    previousMeetings > 0 && `${winner.name} has now won ${previousMeetings + 1} straight meetings in the series.`,
  ].filter(Boolean)

  const closeness =
    Math.abs(homeScore - awayScore) <= 3
      ? pick([
        'The game remained close throughout.',
        'Neither team was able to pull away late.',
        'The matchup came down to the closing moments.',
      ])
      : Math.abs(homeScore - awayScore) >= 15
        ? pick([
          `${winner.name} controlled the game early.`,
          `${winner.name} pulled away in the second half.`,
          `The game tilted heavily in ${winner.name}'s favor after halftime.`,
        ])
        : null

  const summary = [
    pick(intros) + '.',
    pick(scoreLines) + '.',
    closeness,
    pick(standingsLines),
    pick(loserLines),
    pick(contextLines),
  ]
    .filter(Boolean)
    .join(' ')

  return summary
}

const generateTeamSummary = ({
  team,
  teams,
  standings = [],
  recentMatches = [],
  streak,
  classification,
  section,
  ranking,
  previousRanking,
}) => {

  if (!team) { return '' }

  const sectionTeams = _.filter(teams, (_team) => {
    return (
      _.isEqual(_team?.sections, team?.sections) &&
      _.isEqual(_team?.levels, team?.levels)
    )
  })

  const teamName = team?.name ?? 'The team'

  const record = formatRecord(team)

  const position = _.findIndex(standings, (s) => s.key === team.key) + 1

  const intros = [
    `${teamName} continues to build momentum this season`,
    `${teamName} remains one of the stronger teams in the section`,
    `${teamName} has put together a solid campaign`,
    `${teamName} continues to trend upward`,
    `${teamName} has remained competitive throughout the season`,
    `${teamName} continues to strengthen its playoff position`,
  ]

  const recordLines = [
    `${teamName} currently holds a ${record} record.`,
    `The team sits at ${record} on the season.`,
    `${teamName} has compiled a ${record} overall record.`,
  ]

  const standingsLines = [
    position > 0 &&
    `${teamName} currently sits ${position}${getOrdinal(position)} in the standings.`,
    section &&
    `${teamName} continues play in ${section}.`,
    classification &&
    `${teamName} competes in ${classification}.`,
  ].filter(Boolean)

  const streakLines = [
    streak > 0 &&
    `${teamName} has won ${streak} straight games.`,
    streak < 0 &&
    `${teamName} will look to snap a ${Math.abs(streak)}-game losing streak.`,
  ].filter(Boolean)

  const rankingLines = [
    ranking &&
    previousRanking &&
    ranking < previousRanking &&
    `${teamName} moved up to No. ${ranking} in the latest rankings.`,
    ranking &&
    previousRanking &&
    ranking > previousRanking &&
    `${teamName} slipped to No. ${ranking} in the latest rankings.`,
    ranking &&
    !previousRanking &&
    `${teamName} is currently ranked No. ${ranking}.`,
  ].filter(Boolean)

  const recentPerformance = (() => {

    if (_.isEmpty(recentMatches)) { return null }

    const wins = _.filter(recentMatches, (m) => {
      const isHome = m.homeTeamKey === team.key

      const teamScore = isHome ? m.homeScore : m.awayScore
      const oppScore = isHome ? m.awayScore : m.homeScore

      return teamScore > oppScore
    }).length

    const losses = recentMatches.length - wins

    if (wins === recentMatches.length) {
      return pick([
        `${teamName} has won each of its last ${recentMatches.length} games.`,
        `The team has stayed unbeaten over its last ${recentMatches.length} matchups.`,
      ])
    }

    if (losses === recentMatches.length) {
      return pick([
        `${teamName} is searching for consistency after several recent losses.`,
        `The team has dropped its last ${recentMatches.length} contests.`,
      ])
    }

    return pick([
      `${teamName} has gone ${wins}-${losses} over its last ${recentMatches.length} games.`,
      `Recent play has seen ${teamName} post a ${wins}-${losses} stretch.`,
    ])

  })()

  const playoffLines = [
    position > 0 && position <= 4 &&
    `${teamName} remains in strong playoff position.`,
    position > 4 &&
    `${teamName} continues to battle for postseason positioning.`,
  ].filter(Boolean)

  const ds = [
    pick(intros),
    pick(recordLines),
    pick(standingsLines),
    pick(streakLines),
    pick(rankingLines),
    recentPerformance,
    pick(playoffLines),
  ]

  return _.chain(ds)
    .filter(Boolean)
    .map((s) => s.endsWith('.') ? s : `${s}.`)
    .join(' ')
    .value()
}

const getOrdinal = (n) => {

  const s = ['th', 'st', 'nd', 'rd']
  const v = n % 100

  return s[(v - 20) % 10] || s[v] || s[0]
}

export const useEloInfo = ({ teams, matches }) => {

  const calculate_elo = useCallback((teams, matches, applyGroupBoost, asOfDate) => {
    return calculateElo({ teams, matches, applyGroupBoost, asOfDate })
  }, [])

  const enhance_eloInsights = useCallback(({ teamsWithElo, matches, teams, topN = 3 }) => {
    return enhanceEloInsights({ teamsWithElo, matches, teams, topN })
  }, [])

  const calculate_rpi = useCallback(({ teams, matches }) => {
    return calculateRpi({ teams, matches })
  }, [])

  const get_teamVsGroupRecords = useCallback(({ teams, matches }) => {
    return getTeamVsGroupRecords({ teams, matches })
  }, [])

  const adjust_seedsByHeadToHead = useCallback(({ teamsInOrder, matches }) => {
    return adjustSeedsByHeadToHead({ teamsInOrder, matches })
  }, [])

  const get_teamRankingReason = useCallback(({ teamId, teams, matches, eloInfo, sectionStats }) => {
    return getTeamRankingReason({ teamId, teams, matches, eloInfo, sectionStats })
  }, [])

  const get_matchPrediction = useCallback(({ match, teams, includeCommonMatches }) => {
    return getMatchPrediction({ match, teams, matches, includeCommonMatches })
  }, [])

  const generate_matchSummary = useCallback(({ match, teams, }) => {
    return generateMatchSummary({ match, teams, })
  }, [])

  return {
    adjust_seedsByHeadToHead,
    calculate_elo,
    calculate_rpi,
    enhance_eloInsights,
    generate_matchSummary,
    get_matchPrediction,
    get_teamRankingReason,
    get_teamVsGroupRecords,
  }
}

export const sportsEloHelpers = {
  calculateElo,
  enhanceEloInsights,
  calculateRpi,
  getTeamVsGroupRecords,
  adjustSeedsByHeadToHead,
  getTeamRankingReason,
  getMatchPrediction,
  generateMatchSummary,
}